var map = {
	"./feature_buy_en.png": 76107,
	"./feature_buy_id.png": 74237,
	"./feature_buy_ph.png": 5249,
	"./feature_buy_th.png": 19970,
	"./feature_buy_zh.png": 56828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37085;